function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
export default class LocalesMapper {
  /**
   * Enum of all locales available in Braincube with their normalized definition.
   * @enum {locale}
   */

  /**
   * @typedef {string} locale
   */

  constructor(localesToLabelsMap) {
    if (!localesToLabelsMap) {
      throw new Error('You need to set a locales to labels mapping object.');
    }
    if (!localesToLabelsMap[LocalesMapper.LOCALES.EN]) {
      throw new Error('You need to define at least the english label set.');
    }
    this.localesMap = localesToLabelsMap;
  }

  /**
   * Retrieve the full set of labels from the localesMap corresponding to the given locale code.
   * @param {string} locale braincube converted locale
   * @return {Object} Full set of label in the requested lang.
   */
  getLabels(locale) {
    return this.localesMap[locale] || this.localesMap[LocalesMapper.LOCALES.EN];
  }
}
_defineProperty(LocalesMapper, "LOCALES", Object.freeze({
  FR: 'fr',
  EN: 'en',
  EN_US: 'en-US',
  PT_BR: 'pt-br',
  // Not pt-BR because airbnb doesn't support it in the pluralization system => https://github.com/airbnb/polyglot.js/issues/139
  ES: 'es',
  DE: 'de',
  TR: 'tr',
  IT: 'it',
  NL: 'nl',
  PL: 'pl',
  RU: 'ru'
}));